import { render } from "./zixunxq.vue?vue&type=template&id=bca21152"
import script from "./zixunxq.vue?vue&type=script&lang=js"
export * from "./zixunxq.vue?vue&type=script&lang=js"

import "./zixunxq.vue?vue&type=style&index=0&id=bca21152&lang=scss"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__